/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 94b71f76493f6c5beb5c58c46e067d7971541124abdf38ecc8cc66f77eefc233
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './NavDivider.style'

type NavDividerOwnProps = {
  className?: string
}

export type NavDividerProps = NavDividerOwnProps & Omit<ComponentProps<'hr'>, keyof NavDividerOwnProps | 'children'>

function NavDivider(props: NavDividerProps): ReactElement {
  const {
    className = '',
    ...rest
  } = props

  return (
    <hr
      className={cn('NavDivider', className)}
      css={style}
      {...rest}
    />
  )
}

export default NavDivider
